import {Store, Module, ActionContext} from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import Payment from '@/store/entities/weixin/Share';
import AjaxWeixin from '@/lib/ajaxWeixin';
import AjaxFinance from '@/lib/ajaxFinance';
import PageResult from '@/store/entities/page-result';
import AppConst from '@/lib/appConst';

interface ShareState extends ListState<Payment>{
    editShare: Payment;
}

class ShareModule extends ListModule<ShareState, any, Payment>{
    state={
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Payment>(),
        loading: false,
        editShare: new Payment(),
    }
    actions={
        async createWxPaymentQrCode(context: ActionContext<ShareState, any>, payload: any){
            payload.data.appId = AppConst.weixin.appId;
            let reponse = await AjaxWeixin.post('/payment/createWxPaymentQrCode', payload.data);
            return reponse;
        },
        async createAlipayQrCode(context: ActionContext<ShareState, any>, payload: any){
            payload.data.appId = AppConst.alipay.appId;
            let reponse = await AjaxFinance.post('/alipay/createAlipayQrCode', payload.data);
            return reponse;
        },
    };
    mutations={
        setCurrentPage(state: ShareState, page: number){
            state.currentPage = page;
        },
        setPageSize(state: ShareState, pagesize: number){
            state.pageSize = pagesize;
        }
    }
}
const shareModule = new ShareModule();
export default shareModule;